

// 获取视频的链接地址（第一个）
export function get_video_info(item) {

    if (item.articleAttachmentsList && item.articleAttachmentsList.length != 0) {
        let url = "";
        for (const video of item.articleAttachmentsList) {
            console.log(video)
            if (video.category == "VIDEO") {
                url = video.url
                break;
            }
        }

        return url;
    } else {
        return false;
    }
}

/*** 数字转整数 如 10000 转为1万         
    * @param {需要转化的数} num         
    * @param {需要保留的小数位数} point
**/
export const tranNumber = (num, point) => {
    let numStr = num.toString();
    // 一万以内直接返回  
    if (numStr.length < 5) {
        return numStr;
    }
    //大于8位数是亿  
    else if (numStr.length > 8) {
        let decimal = numStr.substring(numStr.length - 8, numStr.length - 8 + point);
        return parseFloat(parseInt(num / 100000000) + '.' + decimal) + '亿';
    }
    //大于5位数是一万 (以1W分割 1W以下全部显示)  
    else if (numStr.length > 4) {
        let decimal = numStr.substring(numStr.length - 4, numStr.length - 4 + point);
        return parseFloat(parseInt(num / 10000) + '.' + decimal) + 'w';
    }
};

export function coverIMG(imglist) {
    // 看是否是有效的值
    if (!(imglist instanceof Array) || imglist.length == 0) {
        return false;
    }

    const img = imglist.find((e) => {
        return e.coverBool == true;
    });
    if (img) {
        return img.url;
    } else {
        return imglist[0].url;
    }
}

// 获取栏目的扩展类型
export function handleEXT(ext, input, moren = false) {
    const res = ext.find(e => e.label == input);
    if (res) {
        // 转为字符串
        return res.fieldValue;
    } else {
        return moren
    }
}


export const browser = {
    versions: function () {
        let u = navigator.userAgent;
        return {
            trident: u.indexOf('Trident') > -1, //IE内核
            presto: u.indexOf('Presto') > -1, //opera内核
            webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
            gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1,//火狐内核
            mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android终端
            iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf('iPad') > -1, //是否iPad
            webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
            weixin: u.indexOf('MicroMessenger') > -1, //是否微信 （2015-01-22新增）
            qq: u.match(/\sQQ/i) == " qq" //是否QQ
        };
    }(),
    language: (navigator.browserLanguage || navigator.language).toLowerCase()
}